<template>
  <div
      :class="[
      'd-flex maxw-100 p-2 gmb-notification-cell',
      { 'gmb-notification-cell--long': noLength },
      { 'gmb-notification-cell--placeholder': isPlaceholder },
      { 'align-items-center rounded-1': !isPlaceholder },
      { 'gmb-notification-cell--error': isError },
      { 'gmb-notification-cell--info': isInfo },
      { 'gmb-notification-cell--success': isSuccess },
    ]"
  >
    <template v-if="!isPlaceholder">
      <div class="d-flex flex-grow-1 w-0 flex-column">
        <FdText tag="span" class="gmb-notification-cell__message">{{
            message
          }}
        </FdText>
      </div>
    </template>
  </div>
</template>

<script>
import FdText from "@/flexdesign/Text";

export default {
  name: "GmbNotificationMessage",

  components: {
    FdText,
  },

  props: {
    message: String,
    type: String,
    isPlaceholder: Boolean,
    noLength: Boolean,
  },

  data() {
    return {};
  },

  computed: {
    isError() {
      return this.type == "error";
    },

    isSuccess() {
      return this.type == "success";
    },

    isInfo() {
      return this.type == "info";
    },
  },

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss">
@import "@/sass/settings/colors";
@import "@/sass/settings/dimensions";
@import "@/sass/settings/fonts";

/* =========================================================================
 * NOTIFICATION CELL
 * ========================================================================= */

.gmb-notification-cell {
  // line-height: $gmb-offset-3;

  &:not(.gmb-notification-cell--long) {
    width: $gmb-cell-width;
  }

  &:not(.gmb-notification-cell--placeholder) {
    &.gmb-notification-cell {
      &--error {
        background-color: rgba(red, 0.6);
      }

      &--info {
        background-color: rgba($gmb-color-theme-2, 0.6);
      }

      &--success {
        background-color: rgba(green, 0.6);
      }
    }
  }

  &__message {
    font-weight: bold;
  }
}
</style>
